"use strict";

exports.__esModule = true;
exports.isFeatureEnabled = void 0;
var _types = require("@wix/ambassador-bookings-services-v2-service/types");
const isFeatureEnabled = ({
  activeFeatures,
  service
}) => {
  const serviceTypeActiveFeatureMap = {
    [_types.ServiceType.APPOINTMENT]: 'applicableForIndividual',
    [_types.ServiceType.COURSE]: 'applicableForCourse',
    [_types.ServiceType.CLASS]: 'applicableForGroups'
  };
  const activeFeaturesKey = serviceTypeActiveFeatureMap[service.type];
  return activeFeaturesKey ? !!activeFeatures[activeFeaturesKey] : true;
};
exports.isFeatureEnabled = isFeatureEnabled;
//# sourceMappingURL=activeFeature.js.map